<section class="table-content">

  <section class="filters">
    <input (input)="getPayments('search', searchPayments)" [(ngModel)]="searchPayments" type="search"
           name="searchClasses"
           placeholder="Search fee, level, term...">

    <div>
      @if (loggedUserRole === 'SUPER_ADMIN' && schools() !== null) {
        <select (change)="getPayments('school_id', filterSchoolId)" [(ngModel)]="filterSchoolId" name="schoolId"
                id="schoolId">
          <option value="" hidden disabled>Select a school</option>

          @for (s of schools()?.payload; track $index) {
            <option [value]="s.id">{{ Helpers.capitalizeWords(s.school_name) }}</option>
          }

        </select>
      }

      <!--      <select (change)="getFees('level_id', filterSchoolId)" [(ngModel)]="filterSchoolId" name="schoolId" id="schoolId">-->
      <!--        <option value="" hidden disabled>Select a level</option>-->
      <!--        <option value="">All Levels</option>-->

      <!--        @for (s of levels()?.payload; track $index) {-->
      <!--          <option [value]="s.id">{{ s.name }}</option>-->
      <!--        }-->

      <!--      </select>-->

      <input type="date" (change)="getPayments('payment_date', paymentDate)" [(ngModel)]="paymentDate" name="paymentDate">

      <select (change)="getPayments('status', paymentStatus)" [(ngModel)]="paymentStatus" name="paymentStatus">
        <option value="" hidden disabled>Select a status</option>
        <option value="">All Statuses</option>

        @for (s of allowedStatuses; track $index) {
          <option [value]="s">{{ Helpers.toSentenceCase(s) }}</option>
        }
      </select>
    </div>
  </section>

  <div class="table-wrapper">
    <table>
      <thead>
      <tr>
        <th>STUDENT NAME</th>
        <th>FEE NAME</th>
<!--        <th>AMOUNT BILLED</th>-->
        <th>PAID</th>
        <th>PAYMENT METHOD</th>
        <th>PAYMENT DATE</th>
        <th>STATUS</th>
        <th class="options-column">ACTIONS</th>
      </tr>
      </thead>

      <tbody>
        @if (isFiltering()) {
          <td colspan="6">
            <app-loading-indicator />
          </td>
        } @else {
          @if (!payments()?.payload?.length) {
            <tr>
              <td colspan="7" class="empty">
                <app-not-found-error>
                  NO PAYMENTS FOUND
                </app-not-found-error>
              </td>
            </tr>
          } @else {
            @for (u of payments()?.payload; track u.id) {
              <tr>
                <td (click)="navigateToStudentDetail(u.student_id)">
                  <button type="button" class="student-link"
                          (click)="navigateToStudentDetail(u.student_id)">
                    {{ Helpers.fullName({ first_name: u.first_name, last_name: u.last_name }) }}
                  </button>
                </td>

                <td class="role">
                  <p class="fee-type">{{ u.fee_name.toUpperCase() }}</p>
                </td>

<!--                <td>-->
<!--                  GH₵{{ u.student_fee_final_amount }}-->
<!--                </td>-->

                <td class="paid">
                  GH₵{{ u.amount }}
                </td>

                <td class="role">
                  <p [ngClass]="u.payment_method">{{ Helpers.replaceUnderscore(u.payment_method) }}</p>
                </td>

                <td>
                  {{ Helpers.formatDate(u.payment_date) }}
                </td>

                <td class="role">
                  <p [ngClass]="u.status">{{ Helpers.replaceUnderscore(u.status) }}</p>
                </td>

                <td class="options-column">
                  <app-action-button>
                    <button (click)="selectPayment(u)" type="button" class="menu-item">View details</button>
                  </app-action-button>
                </td>
              </tr>
            }
          }
        }
      </tbody>
    </table>
  </div>

  <app-pagination
    [page]="payments()?.pagination?.page ?? 0"
    [size]="payments()?.pagination?.size ?? 10"
    [totalElements]="payments()?.pagination?.totalElements ?? 0"
    [totalPages]="payments()?.pagination?.totalPages ?? 0"
    [first]="payments()?.pagination?.first ?? true"
    [last]="payments()?.pagination?.last ?? false"
    [hasNext]="payments()?.pagination?.hasNext ?? false"
    [hasPrevious]="payments()?.pagination?.hasPrevious ?? false"
    (pageChange)="loadPage($event)">
  </app-pagination>

</section>

<section [class.show]="setPaymentDetail()" class="slider">
  <div class="bg" (click)="setPaymentDetail.set(false)"></div>

  <div class="slider-content">
    <div class="slider-heading">
      <div>
        <h5>Payment Details</h5>
        <small>{{ selectedPayment.public_id }}</small>
      </div>

      <div class="role">
        <p [ngClass]="selectedPayment.status">{{ Helpers.replaceUnderscore(selectedPayment.status) }}</p>
      </div>
    </div>

    <div [class.reverse-box]="selectedPayment.status === 'REVERSED'"  class="amount-paid">
      <h6>AMOUNT PAID</h6>
      <h2>GH₵{{ selectedPayment.amount }}</h2>
      <div class="role">
        <p
          [ngClass]="selectedPayment.payment_method">{{ Helpers.replaceUnderscore(selectedPayment.payment_method) }}</p>
      </div>
    </div>

    @if (selectedPayment.status === 'REVERSED') {
      <div class="transaction-info reversed">
        <h6>REVERSED TRANSACTION INFO</h6>

        <div class="transaction-container">
          <div>
            <small>Reversed By</small>
            <p>{{
                Helpers.fullName({
                  first_name: selectedPayment.reversed_by_first_name,
                  last_name: selectedPayment.reversed_by_last_name
                })
              }}</p>
          </div>

          <div>
            <small>Reversal Reason</small>
            <p>{{ Helpers.toSentenceCase(Helpers.replaceUnderscore(selectedPayment.reversal_reason)) }}</p>
          </div>

        </div>
      </div>
    }

    <div class="transaction-info">
      <h6>PAYMENT INFO</h6>

      <div class="transaction-container">
        <div>
          <small>Student</small>
          <p>{{
              Helpers.fullName({
                first_name: selectedPayment.first_name,
                last_name: selectedPayment.last_name
              })
            }}</p>
        </div>

        <div>
          <small>Student ID</small>
          <p>{{ selectedPayment.student_public_id }}</p>
        </div>

        <div>
          <small>Class</small>
          <p>{{ selectedPayment.level_name }}{{ selectedPayment.class_name }}</p>
        </div>

        <div>
          <small>Date</small>
          <p>{{ Helpers.formatDate(selectedPayment.payment_date) }}</p>
        </div>


        <div>
          <small>Payment Method</small>
          <p>{{ Helpers.capitalizeWords(Helpers.replaceUnderscore(selectedPayment.payment_method)) }}</p>
        </div>

        <div class="reference">
          <small>Transaction Reference</small>
          <p>{{ selectedPayment.transaction_reference ? selectedPayment.transaction_reference : 'N/A' }}</p>
        </div>

        @if (selectedPayment.status !== 'REVERSED') {
          <div>
            <small>Date</small>
            <p>{{ Helpers.formatDate(selectedPayment.payment_date) }}</p>
          </div>
        }

        <div>
          <small>Received By</small>
          <p>{{
              Helpers.fullName({
                first_name: selectedPayment.received_by_first_name,
                last_name: selectedPayment.received_by_last_name
              })
            }}</p>
        </div>

      </div>
    </div>

    <div class="fee-summary">
      <h6>FEE RECORD SUMMARY</h6>

      <div class="fee-summary-container">
        <div class="record">
          <small>Total Billed</small>
          <p>GH₵{{ selectedPayment.student_fee_final_amount | number: '1.2-2' }}</p>
        </div>

        <div class="record">
          <small>Total Paid</small>
          <p class="paid">GH₵{{ selectedPayment.student_fee_amount_paid  | number: '1.2-2' }}</p>
        </div>

        <div class="payment-range">
          <div [style.width.%]="paymentPercent"></div>
        </div>

        <div class="record">
          <small [ngClass]="selectedPayment.student_fee_status"
                 class="fee-status">{{ Helpers.capitalizeWords(Helpers.replaceUnderscore(selectedPayment.student_fee_status)) }}</small>
          <small>{{ paymentPercent | number: '1.2-2' }}% paid</small>
        </div>

        <div class="record payment-balance">
          <small>Balance</small>
          <p>GH₵{{ selectedPayment.student_fee_remaining_balance | number: '1.2-2' }}</p>
        </div>

      </div>

    </div>

    @if (studentFeePayments()?.payload?.length) {
      <div class="payment-history">
        <h6>PAYMENT HISTORY</h6>

        <div class="payment-history-container">
          @for (p of studentFeePayments()?.payload; track $index) {
            <div class="payment-row">
              <div class="check-icon">
                <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10.8222 3.24658L4.87005 9.19868L2.16455 6.49318" stroke="#15803D" stroke-width="1.35275" />
                </svg>
              </div>

              <div class="payment-details">
                <p>GH₵{{ p.amount | number: '1.2-2' }}</p>
                <small>{{ p.public_id }}</small>
              </div>

              <div class="method">
                <div class="role"><p
                  [ngClass]="p.payment_method">{{ Helpers.capitalizeWords(Helpers.replaceUnderscore(p.payment_method)) }}</p>
                </div>
                <small>{{ Helpers.formatDate(p.payment_date) }}</small>
              </div>
            </div>
          }
        </div>
      </div>
    }

    @if (selectedPayment.status !== 'REVERSED') {
      <div class="button-container">
      <button (click)="setReversePayment.set(true)" class="button" type="button">
        <svg fill="red" viewBox="0 0 256 256" xmlns="http://www.w3.org/2000/svg" stroke="red">
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
          <g id="SVGRepo_iconCarrier">
            <path
              d="M55.265 167.072c-.975-1.973-3.388-2.796-5.372-1.847L42 169s22.5 53.5 85.5 56c60-1.5 96.627-48.626 97-96.5.373-47.874-37-95.5-95.5-96-57.5-1-79.556 45.004-79.556 45.004-1.073 1.93-1.944 1.698-1.944-.501V51.997a4 4 0 0 0-4-3.997H37c-2.209 0-4 1.8-4 4.008v48.984A3.998 3.998 0 0 0 36.998 105h50.504a3.995 3.995 0 0 0 3.998-3.993v-6.014c0-2.205-1.79-4.02-4.008-4.053l-25.484-.38c-2.214-.033-3.223-1.679-2.182-3.628C59.826 86.932 78 45 128.5 45.5c49 .5 82.751 41.929 82.5 83.242C208 184 166 211 127.5 210c-54.5 0-72.235-42.928-72.235-42.928z"
              fill-rule="evenodd"></path>
          </g>
        </svg>
        Reverse Payment
      </button>
    </div>
    }

  </div>
</section>

@if (setReversePayment()) {
  <section class="pop-up">
    <div class="bg" (click)="setReversePayment.set(false)"></div>

    <form #reversePaymentForm="ngForm" (ngSubmit)="reversePayment(reversePaymentForm)">

      <div class="form-container">

        <div class="reverse-icon">
          <svg fill="red" viewBox="0 0 256 256" xmlns="http://www.w3.org/2000/svg" stroke="red">
            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
            <g id="SVGRepo_iconCarrier">
              <path
                d="M55.265 167.072c-.975-1.973-3.388-2.796-5.372-1.847L42 169s22.5 53.5 85.5 56c60-1.5 96.627-48.626 97-96.5.373-47.874-37-95.5-95.5-96-57.5-1-79.556 45.004-79.556 45.004-1.073 1.93-1.944 1.698-1.944-.501V51.997a4 4 0 0 0-4-3.997H37c-2.209 0-4 1.8-4 4.008v48.984A3.998 3.998 0 0 0 36.998 105h50.504a3.995 3.995 0 0 0 3.998-3.993v-6.014c0-2.205-1.79-4.02-4.008-4.053l-25.484-.38c-2.214-.033-3.223-1.679-2.182-3.628C59.826 86.932 78 45 128.5 45.5c49 .5 82.751 41.929 82.5 83.242C208 184 166 211 127.5 210c-54.5 0-72.235-42.928-72.235-42.928z"
                fill-rule="evenodd"></path>
            </g>
          </svg>
        </div>

        <h6>Reverse Transaction?</h6>

        <p>
          This will reverse <span>GH₵{{ selectedPayment.amount }}</span> paid
          via {{ Helpers.capitalizeWords(Helpers.replaceUnderscore(selectedPayment.payment_method)) }}. The fee record
          balance will be updated accordingly.
        </p>

        <div>
          <label for="reversalReason">Reason for Reversal <span class="required-check">*</span></label>

          <select [(ngModel)]="reversalReason" required name="reversalReason" id="reversalReason">
            <option value="">Select a reason</option>

            @for (r of reasonsOfReversal; track $index) {
              <option [value]="r.value">{{ r.label }}</option>
            }
          </select>
        </div>

        <div class="btn-container">
          <button class="cancel-btn" type="button" (click)="setReversePayment.set(false)">Cancel</button>

          <button class="reverse-btn" [disabled]="reversePaymentForm.invalid" type="submit">
            @if (isEditing()) {
              <app-loading-indicator></app-loading-indicator>
            } @else {
              Yes, Reverse
            }
          </button>
        </div>

      </div>

    </form>
  </section>
}


